function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M288.842,0H6C2.687,0,0,2.687,0,6v282.842c0,3.313,2.687,6,6,6h240.421c3.313,0,6-2.687,6-6s-2.687-6-6-6H12V12h270.842   v276.842c0,3.313,2.687,6,6,6s6-2.687,6-6V6C294.842,2.687,292.155,0,288.842,0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m65.815 62.421c-12.683 0-23 10.317-23 23s10.317 23 23 23 23-10.317 23-23-10.317-23-23-23zm0 34c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.934 11-11 11z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m246.82 79.421h-140c-3.313 0-6 2.687-6 6s2.687 6 6 6h140c3.313 0 6-2.687 6-6s-2.686-6-6-6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m65.815 124.42c-3.313 0-6 2.687-6 6s2.687 6 6 6c6.065 0 11 4.935 11 11s-4.935 11-11 11-11-4.935-11-11c0-3.313-2.687-6-6-6s-6 2.687-6 6c0 12.683 10.317 23 23 23s23-10.317 23-23-10.317-23-23-23z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m246.82 141.42h-140c-3.313 0-6 2.687-6 6s2.687 6 6 6h140c3.313 0 6-2.687 6-6s-2.686-6-6-6z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m65.815 186.42c-12.683 0-23 10.317-23 23s10.317 23 23 23 23-10.317 23-23-10.317-23-23-23zm0 34c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.934 11-11 11z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m246.82 203.42h-140c-3.313 0-6 2.687-6 6s2.687 6 6 6h140c3.313 0 6-2.687 6-6s-2.686-6-6-6z"
});

var SvgMaster = function SvgMaster(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 294.842 294.842",
    viewBox: "0 0 294.84 294.84",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/master.61446e6c.svg";
export { ForwardRef as ReactComponent };